//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { data: {} } },
  created () {
    this.$ajax.get(this.$api.cpPuzzleResult + '?record_id=' + this.$route.query.record_id).then(r => { this.data = r || {} })
  },
  methods: {
    card () {
      this.$ajax.post(this.$api.cpCardGenerate, { scene_id: this.$route.query.scene_id }).then(r => {
        this.$router.push({ path: '/cpCard_display', query: { id: r.card.id } })
      })
    },
    next () {
      this.$ajax.get(this.$api.cpSceneNext + '?scene_id=' + this.$route.query.scene_id).then(id => {
        if (id) this.$router.push({ path: '/cpStart_display', query: { id } })
        else this.$router.push('/cpHome_display')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/context-puzzle/result.vue